import {Component, OnInit} from '@angular/core';
import {ErrorBoxComponent} from '../error-box/error-box.component';
import {ActivatedRoute, Router} from '@angular/router';
import {ErrorHandlingService} from '../../shared/service/error-handling/error-handling.service';
import {Observable, of, Subject, take} from 'rxjs';
import {ErrorInfo} from '../../shared/model/error-info';
import {AsyncPipe} from '@angular/common';
import {MatProgressSpinner} from '@angular/material/progress-spinner';
import {TranslatePipe, TranslateService} from '@ngx-translate/core';
import {DownloadPortalUrisService, TargetTab} from 'download-portal';
import {map} from 'rxjs/operators';
import {environment} from '../../../../environments/environment';


@Component({
    selector: 'myupdates-goto',
    templateUrl: './goto-redirect.component.html',
    styleUrl: './goto-redirect.component.scss',
    imports: [ErrorBoxComponent, AsyncPipe, MatProgressSpinner, TranslatePipe]
})
export class GotoRedirectComponent implements OnInit {

  errorInfo$: Observable<ErrorInfo> = new Subject<ErrorInfo>();
  errorText = '';

  private readonly baseDownloadUrl = '/download';
  private readonly HKNR_SME_FAKTURA_REWE = 81000;
  private readonly HKNR_SME_FAKTURA = 86000;


  constructor(private readonly route: ActivatedRoute,
              private readonly router: Router,
              private readonly errorHandlingService: ErrorHandlingService,
              private readonly translate: TranslateService,
              private readonly downloadPortalUrisService: DownloadPortalUrisService) {
  }

  ngOnInit(): void {
    let redirectTo: string | null = null;
    let dri: string | null = null;

    redirectTo = this.route.snapshot.url.length > 0
      ? this.route.snapshot.url[this.route.snapshot.url.length - 1].path
      : null;

    const redirectParams = this.route.snapshot.queryParams;
    if(redirectParams && redirectParams['dri']) {
      dri = redirectParams['dri'];
    }

    const newRoute$ = this.getRouteBasedOnRedirectTo(redirectTo, dri);
    newRoute$.pipe(take(1)).subscribe(newRoute => {
      if (newRoute === '') {
        this.getDedicatedErrortextForFailedLink(redirectTo);
        this.errorInfo$ = of(this.errorHandlingService.toErrorInfo(new Error('No redirect path found')));
      }
      else {
        this.activateRedirect(newRoute);
      }
    });
  }

  activateRedirect(redirect: string): Promise<boolean> {
    return this.router.navigate([redirect]);
  }

  private getRouteBasedOnRedirectTo(redirectTo: string | null, dri: string | null): Observable<string> {
    const routes: { [key: string]: Observable<string> } = {
      'mainrelease': of(environment.mainReleaseUrlPart),

      'mainrelease-lfu': of(environment.mainReleaseLfuUrlPart),

      'sme': of(`${this.baseDownloadUrl}${this.downloadPortalUrisService.getTabUri(TargetTab.SME)}`),

      'base-sw': of(`${this.baseDownloadUrl}${this.downloadPortalUrisService.getTabUri(TargetTab.BASE)}`),

      'additional-sw': of(`${this.baseDownloadUrl}${this.downloadPortalUrisService.getTabUri(TargetTab.ADDITIONAL)}`),

      'sme-faktura-rewe': this.downloadPortalUrisService.getMainReleaseDetailPage(this.HKNR_SME_FAKTURA_REWE)
                .pipe(map(uri => uri ? `${this.baseDownloadUrl}${uri}` : '')),

      'sme-faktura': this.downloadPortalUrisService.getMainReleaseDetailPage(this.HKNR_SME_FAKTURA)
                .pipe(map(uri => uri ? `${this.baseDownloadUrl}${uri}` : '')),

      'sme-sr': this.downloadPortalUrisService.getServiceReleaseDetailPage()
                .pipe(map(uri => uri ? `${this.baseDownloadUrl}${uri}` : '')),

      'additional-sw-product': of(`${this.baseDownloadUrl}${this.downloadPortalUrisService
                                                                .getAdditionalSoftwareDetailsPage(dri ?? '')}`)
    };

    return routes[redirectTo ?? ''] || of('');
  }

  private getDedicatedErrortextForFailedLink(redirectTo: string | null): void {
    const errorMap: { [key: string]: string } = {
      'sme': 'goto.error_goto_redirect_text_sme',
      'base-sw': 'goto.error_goto_redirect_text_base_sw',
      'additional-sw': 'goto.error_goto_redirect_text_additional_sw',
      'sme-faktura-rewe': 'goto.error_goto_redirect_text_current',
      'sme-faktura': 'goto.error_goto_redirect_text_current',
      'sme-sr': 'goto.error_goto_redirect_text_current'
    };

    const defaultError = 'goto.error_goto_redirect_text';
    const dedicatedError = errorMap[redirectTo ?? ''] || defaultError;

    this.translate.get(dedicatedError).pipe(take(1)).subscribe(res => this.errorText = res);
  }

}
